export enum MapTileType {
  OpenStreet = 'open-street',
  GoogleHybrid = 'google-hybrid',
  GoogleRoadmap = 'google-roadmap',
  GoogleHybridUnofficial = 'google-hybrid-unofficial',
  Yandex = 'yandex',
  GoMap = 'go-map'
}

export const mapTileTypeLabels: Record<MapTileType, string> = {
  [MapTileType.OpenStreet]: 'OpenStreetMap',
  [MapTileType.GoogleHybrid]: 'Google Hybrid',
  [MapTileType.GoogleRoadmap]: 'Google Roadmap',
  [MapTileType.GoogleHybridUnofficial]: 'Google Hybrid',
  [MapTileType.Yandex]: 'Yandex Map',
  [MapTileType.GoMap]: 'GoMap.Az'
};

export interface MapType {
  id: MapTileType;
  name: string;
  iconClass: string;
  active: boolean;
}

export interface MapSettingsType {
  default_map: MapTileType;
  enabled_osm: boolean;
  google_map_key: string;
  use_hybrid: boolean;
  use_roadmap: boolean;
  use_gomap: boolean;
}

export interface DesktopMapKeys extends MapSettingsType {
  settingsAreFromCurrentUser: boolean;
}
